module.exports = __webpack_public_path__ + "static/media/mask_group_deposit.6c919872.png";